export default __webpack_public_path__ + "static/media/Proreview-3.dc482926.jpg";